const FromArr = [{
		title: "单据号：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请输入",
		width: 160,
		height: 32,
		disabled: false,
		marginLeft: 24,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		title: "空转日期：",
		StartTime: '',
		EndTime: '',
		inputtype: "dateSection",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "date",
		placeholder: "选择日期",
		widthLeft: 160,
		widthRight: 160,
		heightLeft: 32,
		heightRight: 32,
		disabled: false,
		marginLeft: 30,
		marginTop: 28,
		displayVal: "inline-block",
		fontWeightVal: 500
	}, {
		title: "付款方：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请输入",
		width: 160,
		height: 32,
		disabled: false,
		marginLeft: 24,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500
	}, {
		title: "终端医院：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请输入",
		width: 160,
		height: 32,
		disabled: false,
		marginLeft: 24,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500
	}, {
		title: "产品线：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 170,
		height: 32,
		disabled: false,
		marginLeft: 24,
		marginTop: 28,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	},
	{
		title: "录入日期：",
		StartTime: '',
		EndTime: '',
		inputtype: "dateSection",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "date",
		placeholder: "选择日期",
		widthLeft: 160,
		widthRight: 160,
		heightLeft: 32,
		heightRight: 32,
		disabled: false,
		marginLeft: 30,
		marginTop: 28,
		displayVal: "inline-block",
		fontWeightVal: 500
	}, {
		title: "产品型号：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请输入",
		width: 160,
		height: 32,
		disabled: false,
		marginLeft: 24,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500
	}, {
		title: "产品名称：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请输入",
		width: 160,
		height: 32,
		disabled: false,
		marginLeft: 24,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500
	}, {
		title: "批号：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请输入",
		width: 160,
		height: 32,
		disabled: false,
		marginLeft: 36,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500
	}, {
		title: "创建方：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请输入",
		width: 160,
		height: 32,
		disabled: false,
		marginLeft: 36,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500
	}
]
export default FromArr;